import { render, staticRenderFns } from "./DmsUserProfileTabs.vue?vue&type=template&id=8aff2658"
import script from "./DmsUserProfileTabs.vue?vue&type=script&lang=js"
export * from "./DmsUserProfileTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports